// Copyright ©️ 2026 eVolve MEP, LLC

import { type WorkCell, useEvolveDelete } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';

type Props = ModalRegistryManagedProps & {
  workCell: WorkCell;
  onWorkCellDeleted: () => void;
};

export const DeleteWorkCellModal = ({ workCell, onWorkCellDeleted, ...props }: Props) => {
  const { apiCall: deleteWorkCellApiCall } = useEvolveDelete(`shop/workCell/${workCell.workCellId}`);
  return (
    <WrappedModal
      title="Delete work cell"
      confirmationText="Delete"
      onConfirm={async () => {
        await deleteWorkCellApiCall();
        onWorkCellDeleted();
        notifications.show({
          title: 'Successfully deleted work cell',
          message: `Work cell ${workCell.workCellName} deleted.`,
          color: 'green',
        });
      }}
      {...props}
    >
      <Text>
        Are you sure you want to delete <b>{workCell.workCellName}</b>?
      </Text>
    </WrappedModal>
  );
};
